export const mapRole = (abbr) => {
  switch (abbr) {
    case "T":
      return "ticketbot-admin"
    case "L":
      return "leadbot-admin"
    case "S":
      return "agent"
    case "C":
      return "client-admin"
    case "M":
      return "superadmin"
    case "A":
      return "admin"
    default:
      return "visitor"
  }
}
